<sq-breadcrumb class="m-0">
    @for (breadcrumb of breadcrumbs | async; track breadcrumb; let last = $last) {
        @if (breadcrumb?.label && (breadcrumb?.url?.slice(-1) === '/' || last)) {
            <sq-breadcrumb-item
                [active]="last"
                [url]="breadcrumb?.url"
                [attributes]="breadcrumb?.attributes"
                [linkProps]="breadcrumb?.linkProps">
                {{ breadcrumb?.label }}
            </sq-breadcrumb-item>
        }
    }
</sq-breadcrumb>
